import { useMemo } from "react";
import useChartSelections from "components/charting/hooks/useChartSelections";
import useProfileTypeQueryState from "components/charting/hooks/useProfileTypeQueryState";
import AthleteProfileChartHelpers from "features/AthleteProfile/AthleteProfileChart/helpers/AthleteProfileChartHelpers";
import { MetadataType } from "types/metadata";

// The profiling chart plots the rep metric of the selected profile type, not the shared rep metric selection.
function useProfilingRepMetric() {
  const selections = useChartSelections();
  const [profileType] = useProfileTypeQueryState();
  const measure = selections.measures[0];
  const exercise = measure?.type === MetadataType.EXERCISE ? measure.metadata : null;

  return useMemo(
    () => AthleteProfileChartHelpers.getProfileTypeRepMetric(exercise, profileType),
    [exercise, profileType]
  );
}

export default useProfilingRepMetric;
